// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetStatistics200ResponseDtas
 */
export interface GetStatistics200ResponseDtas {
    /**
     * DTAs in ACTIVE stage
     * @type {number}
     * @memberof GetStatistics200ResponseDtas
     */
    active: number;
    /**
     * DTAs in REVIEW stage
     * @type {number}
     * @memberof GetStatistics200ResponseDtas
     */
    pendingReviews: number;
    /**
     * DTAs in DRAFT stage
     * @type {number}
     * @memberof GetStatistics200ResponseDtas
     */
    pendingValidations: number;
    /**
     * Total DTAs across assigned studies
     * @type {number}
     * @memberof GetStatistics200ResponseDtas
     */
    total: number;
}

/**
 * Check if a given object implements the GetStatistics200ResponseDtas interface.
 */
export function instanceOfGetStatistics200ResponseDtas(value: object): value is GetStatistics200ResponseDtas {
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('pendingReviews' in value) || value['pendingReviews'] === undefined) return false;
    if (!('pendingValidations' in value) || value['pendingValidations'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function GetStatistics200ResponseDtasFromJSON(json: any): GetStatistics200ResponseDtas {
    return GetStatistics200ResponseDtasFromJSONTyped(json, false);
}

export function GetStatistics200ResponseDtasFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStatistics200ResponseDtas {
    if (json == null) {
        return json;
    }
    return {
        
        'active': json['active'],
        'pendingReviews': json['pendingReviews'],
        'pendingValidations': json['pendingValidations'],
        'total': json['total'],
    };
}

export function GetStatistics200ResponseDtasToJSON(json: any): GetStatistics200ResponseDtas {
    return GetStatistics200ResponseDtasToJSONTyped(json, false);
}

export function GetStatistics200ResponseDtasToJSONTyped(value?: GetStatistics200ResponseDtas | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'active': value['active'],
        'pendingReviews': value['pendingReviews'],
        'pendingValidations': value['pendingValidations'],
        'total': value['total'],
    };
}
